import { initButtonCollapse } from './components/collapse';

document.addEventListener('DOMContentLoaded', () => {
    initButtonCollapse();
});
